/** F606 Users page — bridge-backed. */
import { Users } from 'lucide-react';
import F606DataPage from './F606DataPage';

export default function F606UsersPage() {
  return (
    <F606DataPage
      entity="users"
      titleAr="الحسابات"
      titleEn="Users"
      icon={Users}
      emptyIcon={Users}
      columns={[
        {
          key: 'id',
          ar: '#', en: '#',
          render: (r) => <span className="font-mono text-white/40 text-[10px]" dir="ltr">{String(r.id || '').slice(0, 8)}</span>,
          className: 'w-20',
        },
        {
          key: 'full_name',
          ar: 'الاسم', en: 'Name',
          render: (r) => (
            <span className="font-bold text-white">
              {r.full_name || r.first_name || '—'}
              {r.is_guest && <span className="ms-2 text-[9px] px-1.5 py-0.5 rounded-full bg-white/10 text-white/60">guest</span>}
            </span>
          ),
        },
        { key: 'email', ar: 'الإيميل', en: 'Email', render: (r) => <span className="font-mono text-[11px]" dir="ltr">{r.email || '—'}</span> },
        { key: 'phone', ar: 'الجوّال', en: 'Phone', render: (r) => <span className="font-mono text-[11px]" dir="ltr">{r.phone ? `${r.country_code || ''} ${r.phone}` : '—'}</span> },
        { key: 'region', ar: 'الدولة', en: 'Region', className: 'w-16' },
        {
          key: 'created_at',
          ar: 'تاريخ التسجيل', en: 'Joined',
          render: (r) => r.created_at ? new Date(r.created_at).toLocaleDateString() : '—',
          className: 'w-32 text-[11px] text-white/60',
        },
      ]}
    />
  );
}
